module.exports = __webpack_public_path__ + "media/images/fichaDefault-8b17098a2e8a8f44ab46eb4d3ce8d848.png";